import React from 'react'
import { Layout } from '../Shared'
import Header from './sections/Header'
import ProductsContainer from './sections/Products/ProductsContainer'
import helmetProps from './helmetProps'
import breakpoints from './breakpoints'
import './Downloads.global.scss'

/** Container class for product downloads */
class Download extends React.Component {
  render() {
    const { widthClass } = this.props

    return (
      <div id="downloads">
        <Header />
        <ProductsContainer widthClass={widthClass} />
      </div>
    )
  }
}

export default props => (
  <Layout breakpoints={breakpoints}>
    <Download {...props} />
  </Layout>
)

export { helmetProps }
